import tippy from "tippy.js";

class TooltippsBadges {

  #badges = [];
  #instances = [];
  #options = {};

  constructor(options = {}) {
    this.#badges = [];
    this.#instances = [];

    const defaultOptions = {
      placement: "bottom",
      arrow: false,
      trigger: "mouseenter",
    };

    this.#options = Object.assign({}, defaultOptions, options);
  }

  init() {
    if (this.#instances.length) {
      this.#destroy();
    }
    this.#badges = document.querySelectorAll(".products-list__item-badge");
    if (!this.#badges.length) return;
    this.#badges.forEach((badge) => {
      const el = badge.querySelector(".tooltip");
      if (!el) return;
      const content = el.innerText;
      this.#initializeTooltip(badge, content);
    });
  }

  #destroy() {
    this.#instances.forEach((instance) => {
      instance.destroy();
    });
    this.#instances = [];
  }

  #initializeTooltip(el, content) {
    const instance = tippy(el, {
      ...this.#options,
      content,
    });
    this.#instances.push(instance);
  }
}

export default TooltippsBadges;
